import { mailTemplateType } from 'constants/mailTemplateType';
import Usage from 'constants/usage';
import { eFormMode } from './enums';

export const convertFormIntoPayload = (formData, type = eFormMode.create) => {
    const phoneNumber = formData.disableInvitationByPhone
        ? {}
        : { phone_number: formData.phone_number };
    const admin =
        type === eFormMode.create
            ? {
                  ...phoneNumber,
                  email: formData.email,
              }
            : null;
    return {
        admin,
        name: formData.name,
        route: formData.route,
        plan_id: formData.plan_id,
        categories_threshold: Number(formData.categories_threshold),
        users_threshold: Number(formData.users_threshold),
        admins_threshold: Number(formData.admins_threshold),
        is_demo: formData.is_demo ?? false,
        demo_expires_at:
            formData.is_demo && formData.demo_expires_at ? formData.demo_expires_at : null,
        mail_templates: [
            {
                type: mailTemplateType.RegistrationAdmin,
                body_sms: formData.admin_sms_template,
                body_email: formData.admin_email_template,
            },
            {
                type: mailTemplateType.RegistrationUser,
                body_sms: formData.user_sms_template,
                body_email: formData.user_email_template,
            },
        ],
        client_usages: [
            ...(!formData.allowFileUpload ? [Usage.DisableUpload] : []),
            ...(formData.notIncludeReportRole ? [Usage.DisableInternalReport] : []),
            ...(formData.disableCSVDownload ? [Usage.DisableCSV] : []),
            ...(formData.disableAccessRestriction ? [Usage.DisableIpRestriction] : []),
            ...(formData.disableRoleManagement ? [Usage.DisableRoleManagement] : []),
            ...(formData.disableReplyModification ? [Usage.DisablePostUpdate] : []),
            ...(formData.disableAddAdmin ? [Usage.DisableAddAdmin] : []),
            ...(formData.disableInvitationByPhone ? [Usage.DisableInvitationByPhone] : []),
            ...(formData.disableUserGroup ? [Usage.DisableUserGroup] : []),
            ...(formData.disablePostClose ? [Usage.DisablePostClose] : []),
            ...(formData.disableAnouncementFunction ? [Usage.DisableAnouncementFunction] : []),
            ...(formData.disableUserInvitationUrlFunction
                ? [Usage.DisableUserInvitationUrlFunction]
                : []),
            ...(formData.disableGroupFilter ? [Usage.DisableGroupFilter] : []),
            ...(formData.disableSecurityPolicy ? [Usage.DisableSecurityPolicy] : []),
            ...(formData.disableExternalPost ? [Usage.DisableExternalPost] : []),
            ...(formData.disableAutoReplyNewPost ? [Usage.DisableAutoReplyNewPost] : []),
            ...(formData.disableBulletinBoard ? [Usage.DisableBulletinBoard] : []),
            ...(formData.disableEnqueteOrVote ? [Usage.DisableEnqueteOrVote] : []),
            ...(formData.disablePosting ? [Usage.DisablePosting] : []),
            ...(formData.disableEnquete ? [Usage.DisableEnquete] : []),
            ...(formData.disablePostFormat ? [Usage.DisablePostFormat] : []),
            ...(formData.disableSSO ? [Usage.DisableSSO] : []),
            ...(formData.disableSocialLoginGoogle ? [Usage.DisableSocialLoginGoogle] : []),
            ...(formData.disableSocialLoginMicrosoft ? [Usage.DisableSocialLoginMicrosoft] : []),
        ],
    };
};

export const convertUsageIdsIntoForm = usageIds => {
    if (!Array.isArray(usageIds)) return {};
    return {
        allowFileUpload: !hasUsageId(usageIds, Usage.DisableUpload),
        notIncludeReportRole: hasUsageId(usageIds, Usage.DisableInternalReport),
        disableCSVDownload: hasUsageId(usageIds, Usage.DisableCSV),
        disableAccessRestriction: hasUsageId(usageIds, Usage.DisableIpRestriction),
        disableRoleManagement: hasUsageId(usageIds, Usage.DisableRoleManagement),
        disableReplyModification: hasUsageId(usageIds, Usage.DisablePostUpdate),
        disableAddAdmin: hasUsageId(usageIds, Usage.DisableAddAdmin),
        disableInvitationByPhone: hasUsageId(usageIds, Usage.DisableInvitationByPhone),
        disableUserGroup: hasUsageId(usageIds, Usage.DisableUserGroup),
        disablePostClose: hasUsageId(usageIds, Usage.DisablePostClose),
        disableAnouncementFunction: hasUsageId(usageIds, Usage.DisableAnouncementFunction),
        disableUserInvitationUrlFunction: hasUsageId(
            usageIds,
            Usage.DisableUserInvitationUrlFunction
        ),
        disableSecurityPolicy: hasUsageId(usageIds, Usage.DisableSecurityPolicy),
        disableExternalPost: hasUsageId(usageIds, Usage.DisableExternalPost),
        disableAutoReplyNewPost: hasUsageId(usageIds, Usage.DisableAutoReplyNewPost),
        disableGroupFilter: hasUsageId(usageIds, Usage.DisableGroupFilter),
        disableBulletinBoard: hasUsageId(usageIds, Usage.DisableBulletinBoard),
        disableEnqueteOrVote: hasUsageId(usageIds, Usage.DisableEnqueteOrVote),
        disablePosting: hasUsageId(usageIds, Usage.DisablePosting),
        disableEnquete: hasUsageId(usageIds, Usage.DisableEnquete),
        disablePostFormat: hasUsageId(usageIds, Usage.DisablePostFormat),
        disableSSO: hasUsageId(usageIds, Usage.DisableSSO),
        disableSocialLoginGoogle: hasUsageId(usageIds, Usage.DisableSocialLoginGoogle),
        disableSocialLoginMicrosoft: hasUsageId(usageIds, Usage.DisableSocialLoginMicrosoft),
    };
};

export const hasUsageId = (clientUsages, usageId) => !!clientUsages.includes(usageId);
